import Vue from 'vue'
export const DialogEventBus = new Vue()